(function () {
  let registered = false;
  let registerAttempts = 0;
  let cartRefreshRequest = null;
  let lastCartSyncAt = 0;

  function cartSections() {
    return [
      'drawer-cart-items',
      'drawer-cart-footer',
      'cart-items',
      'cart-footer',
      'cart-item-count',
      'cart-live-region',
    ].join(',');
  }

  function parseSectionHTML(htmlString) {
    if (window.parseDOMFromString) return parseDOMFromString(htmlString);

    window.___cascadeDOMParser = window.___cascadeDOMParser || new DOMParser();
    return window.___cascadeDOMParser.parseFromString(htmlString, 'text/html');
  }

  function cartCountFromSections(response) {
    if (!response || !response.sections || !response.sections['cart-item-count']) return null;

    const countText = parseSectionHTML(response.sections['cart-item-count'])
      .firstElementChild
      .textContent
      .trim();
    const count = parseInt(countText, 10);

    return Number.isNaN(count) ? null : count;
  }

  function updateVisibleCartCount(count) {
    if (count === null) return;

    document.querySelectorAll('[x-text*="cart_count.count"]').forEach((el) => {
      el.textContent = count;
    });
  }

  function hasAlpineCartStore() {
    try {
      return !!(window.Alpine && Alpine.store && Alpine.store('cart_count'));
    } catch (error) {
      return false;
    }
  }

  function sectionNameForCurrentRoot(root, drawerSection, pageSection) {
    const xData = root.getAttribute('x-data') || '';
    return xData.indexOf("'drawer'") !== -1 || xData.indexOf('"drawer"') !== -1
      ? drawerSection
      : pageSection;
  }

  function patchSectionRoot(selector, response, drawerSection, pageSection) {
    const current = document.querySelector(selector);
    if (!current || !response || !response.sections) return;

    const sectionName = sectionNameForCurrentRoot(current, drawerSection, pageSection);
    const sectionHTML = response.sections[sectionName];
    if (!sectionHTML) return;

    const next = parseSectionHTML(sectionHTML).querySelector(selector);
    if (!next) return;

    current.replaceWith(next);
    if (window.Alpine && Alpine.initTree) Alpine.initTree(next);
  }

  function patchCartDom(response) {
    updateVisibleCartCount(cartCountFromSections(response));

    if (hasAlpineCartStore()) return;

    patchSectionRoot('[data-cart-items]', response, 'drawer-cart-items', 'cart-items');
    patchSectionRoot('[data-cart-footer]', response, 'drawer-cart-footer', 'cart-footer');
  }

  function refreshCartSections(force) {
    const now = Date.now();
    if (!force && now - lastCartSyncAt < 1000) return cartRefreshRequest;
    if (cartRefreshRequest || !window.theme || !theme.routes) return cartRefreshRequest;

    lastCartSyncAt = now;

    const separator = theme.routes.cart_url.indexOf('?') === -1 ? '?' : '&';
    const url = theme.routes.cart_url + separator + 'sections=' + cartSections();

    cartRefreshRequest = fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((sectionsResponse) => {
        const response = { sections: sectionsResponse };

        patchCartDom(response);
        document.body.dispatchEvent(
          new CustomEvent('switch:cart:refresh', {
            bubbles: true,
            detail: { response },
          })
        );
      })
      .catch(() => {})
      .finally(() => {
        cartRefreshRequest = null;
      });

    return cartRefreshRequest;
  }

  function bindStandaloneCartSync() {
    window.addEventListener('pageshow', () => {
      window.setTimeout(() => refreshCartSections(true), 0);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refreshCartSections();
    });

    window.addEventListener('focus', () => {
      refreshCartSections();
    });
  }

  function cartCountStore() {
    return {
      count: (window.theme && window.theme.cartItemCount) || 0,
      _bound: false,
      _lastRefreshAt: 0,
      _refreshing: null,
      init() {
        if (this._bound) return;
        this._bound = true;

        window.addEventListener('switch:cart:afteradditem', (e) => {
          this._setFromFetchedSection(e.detail.response);
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          this._setFromFetchedSection(e.detail.response);
        });

        window.addEventListener('switch:cart:refresh', (e) => {
          this._setFromFetchedSection(e.detail.response);
        });

        window.addEventListener('pageshow', (event) => {
          const perf = window.performance;
          const navigationEntry = perf && perf.getEntriesByType
            ? perf.getEntriesByType('navigation')[0]
            : null;
          const restoredFromHistory =
            event.persisted ||
            (navigationEntry && navigationEntry.type === 'back_forward');

          if (restoredFromHistory) this.refreshIfStale(true);
        });

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') this.refreshIfStale();
        });

        window.addEventListener('focus', () => {
          this.refreshIfStale();
        });

        window.setTimeout(() => {
          this.refreshIfStale(true);
        }, 0);
      },
      _setFromFetchedSection(data) {
        const nextCount = cartCountFromSections(data);

        if (nextCount !== null) this.count = nextCount;
      },
      refreshIfStale(force) {
        const now = Date.now();
        if (!force && now - this._lastRefreshAt < 1000) return this._refreshing;

        this._lastRefreshAt = now;
        return this.refresh();
      },
      refresh() {
        this._refreshing = refreshCartSections(true);
        return this._refreshing;
      },
      countWithText() {
        let string = theme.strings.itemCountOther;

        if (this.count === 1) {
          string = theme.strings.itemCountOne;
        }

        return string.replace('{{ count }}', this.count);
      },
    };
  }

  function registerCartCountStore() {
    if (registered || !window.Alpine) return false;

    try {
      if (Alpine.store('cart_count')) {
        registered = true;
        return true;
      }
    } catch (error) {
      // Older Alpine builds throw when reading a store before it exists.
    }

    Alpine.store('cart_count', cartCountStore());
    registered = true;
    return true;
  }

  bindStandaloneCartSync();
  document.addEventListener('alpine:init', registerCartCountStore);

  if (!registerCartCountStore()) {
    const registerTimer = window.setInterval(() => {
      registerAttempts += 1;
      if (registerCartCountStore() || registerAttempts >= 100) {
        window.clearInterval(registerTimer);
      }
    }, 50);
  }
})();
